// ../../react-shim.js
import React from "react";

// src/refs.ts
import { isFunction } from "@nature-ui/utils";
function assignRef(ref, value) {
  if (ref == null)
    return;
  if (isFunction(ref)) {
    ref(value);
    return;
  }
  try {
    ref.current = value;
  } catch (error) {
    throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
  }
}
function mergeRefs(...refs) {
  return (node) => {
    refs.forEach((ref) => assignRef(ref, node));
  };
}

// src/context.ts
import React2 from "react";
function createContext(options = {}) {
  const {
    strict = true,
    errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",
    name
  } = options;
  const Context = React2.createContext(void 0);
  Context.displayName = name;
  function useContext() {
    var _a;
    const context = React2.useContext(Context);
    if (!context && strict) {
      const error = new Error(errorMessage);
      error.name = "ContextError";
      (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext);
      throw error;
    }
    return context;
  }
  return [
    Context.Provider,
    useContext,
    Context
  ];
}

// src/children.ts
import React3 from "react";
function getValidChildren(children) {
  return React3.Children.toArray(children).filter(
    (child) => React3.isValidElement(child)
  );
}
export {
  assignRef,
  createContext,
  getValidChildren,
  mergeRefs
};
